import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { StorageService } from './../../../services/API/storage/storage.service';
import { NewFolderComponent } from './components/new-folder/new-folder.component';
import { RenameComponent } from './components/rename/rename.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { NotificationServiceService } from './../../../services/notification-service/notification-service.service';
import { ConfirmDialogComponent } from './../shared/components/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-filemanager',
    templateUrl: './filemanager.component.html',
    styleUrls: ['./filemanager.component.css'],
    standalone: false
})
export class FilemanagerComponent implements OnInit {

  showProgressBar: boolean = true;
  structure: any = [];
  path: string = "";
  pathBeautiful: string = "";
  action: string = "";
  origen: string = "";
  destino: string = "";
  pasteDisabled: boolean = true;
  displayedColumns = ['actions', 'name', 'type', 'size', 'lastModified'];
  dataSource = new MatTableDataSource(this.structure);

  constructor(private dialog: MatDialog, private storageService: StorageService, private notificationService: NotificationServiceService) {}

  ngOnInit(): void {
    this.getStructure(this.path);
    this.prepareTable();
  }

  getStructure(path: string) {
    this.showProgressBar = true;
    this.storageService.getStructure(path).subscribe(result => {
      this.structure = result["data"];
      this.path = result["path"];
      this.pathBeautiful = result["path"].substring(4);
      this.prepareTable();
      this.showProgressBar = false;
    }, error => {
      this.notificationService.openSnackBar("¡Se ha producido un error!");
    });
  }

  goBack() {
    var path = this.path.slice(0, this.path.lastIndexOf("/"));
    this.getStructure(path);
  }

  prepareTable() {
    this.dataSource = new MatTableDataSource(this.structure);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getFileExtension(filename: string) {
    let ext = filename.split(".").pop();
    let obj = this.iconList.filter(row => {
      if (row.type === ext) {
        return true;
      }
    });
    if (obj.length > 0) {
      let icon = obj[0].icon;
      return icon;
    } else {
      return "insert_drive_file";
    }
  }

  openFolder(file: string) {
    var path = this.path +"/"+ file;
    this.getStructure(path);
  }

  newFolder() {
    const dialog = this.dialog.open(NewFolderComponent, {
      width: '90%',
      maxWidth: '350px',
    });
    dialog.afterClosed().subscribe(result => {
      if(result){
        var directory = this.path+"/"+result["name"];
        this.showProgressBar = true;
        this.storageService.newFolder(directory).subscribe(() => {
          this.notificationService.openSnackBar("¡Carpeta creada correctamente!");
          this.getStructure(this.path);
        }, error => {
          if(error.error.msg){
            this.notificationService.openSnackBar("¡La carpeta ya existe!");
          }else{
            this.notificationService.openSnackBar("¡Se ha producido un error!");
          }
        });
      }
    });
  }

  deleteFolder(name: string) {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Eliminar carpeta', body: '¿Seguro que deseas eliminar esta carpeta?'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.showProgressBar = true;
        var directory = this.path+"/"+name;
        this.storageService.deleteFolder(directory).subscribe(() => {
          this.notificationService.openSnackBar("¡Carpeta eliminada correctamente!");
          this.getStructure(this.path);
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
        });
      }
    });
  }

  deleteFile(name: string) {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Eliminar fichero', body: '¿Seguro que deseas eliminar este fichero?'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.showProgressBar = true;
        var file = this.path+"/"+name;
        this.storageService.deleteFile(file).subscribe(() => {
          this.notificationService.openSnackBar("¡Fichero eliminado correctamente!");
          this.getStructure(this.path);
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
        });
      }
    });
  }

  rename(name: string) {
    const confirmDialog = this.dialog.open(RenameComponent, {
      data: {title: 'Renombrar', name: name},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result){
        this.showProgressBar = true;
        var oldName = this.path+"/"+name;
        var newName = this.path+"/"+result["name"];
        this.storageService.rename(oldName, newName).subscribe(() => {
          this.notificationService.openSnackBar("¡Se ha renombrado correctamente!");
          this.getStructure(this.path);
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
        });
      }
    });
  }

  uploadFiles(){
    const dialog = this.dialog.open(UploadFileComponent, {
      width: '500px',
      maxWidth: '90%',
      data: {'path': this.path},
    });
    dialog.afterClosed().subscribe(result => {
      if(result){
        this.getStructure(this.path);
      }
    });
  }

  downloadFile(name: string) {
    var path = this.path+"/"+name;
    this.showProgressBar = true;
    this.storageService.download(path, name).subscribe((response: any) => {
      let dataType = response.type;
      let binaryData = [];
      binaryData.push(response);
      let downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
      if (name){ downloadLink.setAttribute('download', name); }
      document.body.appendChild(downloadLink);
      downloadLink.click();
      this.showProgressBar = false;
      this.notificationService.openSnackBar("¡Fichero descargado!");
    }, error => {
      this.showProgressBar = false;
    });
  }


  compressFolder(name: string) {
    var path = this.path+"/"+name;
    this.showProgressBar = true;
    this.storageService.compress(path, name).subscribe((response: any) => {
      this.getStructure(this.path);
      this.showProgressBar = false;
      this.notificationService.openSnackBar("¡Carpeta comprimida!");
    }, error => {
      this.showProgressBar = false;
    });
  }


  copy(name: string, action: string) {
    this.action = action;
    this.origen = this.path + "/" + name;
    this.pasteDisabled = false;
  }

  paste() {
    console.log(this.origen);
    console.log((this.path + "/" + this.destino));
    if(this.origen === (this.path + "/" + this.destino)){
      this.notificationService.openSnackBar("¡Estas en el mismo directorio!");
    }else {
      if(this.action === 'copy'){
        this.storageService.copy(this.origen, (this.path + "/" + this.destino)).subscribe((response: any) => {
          this.getStructure(this.path);
          this.showProgressBar = false;
          this.pasteDisabled = true;
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.showProgressBar = false;
          this.pasteDisabled = true;
        });
      }
      if(this.action === 'move'){
        this.storageService.move(this.origen, (this.path + "/" + this.destino)).subscribe((response: any) => {
          this.getStructure(this.path);
          this.pasteDisabled = true;
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.showProgressBar = false;
          this.pasteDisabled = true;
        });
      }
    }
  }

  iconList = [
    { type: "doc", icon: "description" },
    { type: "docx", icon: "description" },
    { type: "odt", icon: "description" },
    { type: "xls", icon: "insert_chart_outlined" },
    { type: "xlsx", icon: "insert_chart_outlined" },
    { type: "ods", icon: "insert_chart_outlined" },
    { type: "ppt", icon: "note" },
    { type: "pptx", icon: "note" },
    { type: "html", icon: "code" },
    { type: "htm", icon: "code" },
    { type: "txt", icon: "text_snippet" },
    { type: "pdf", icon: "picture_as_pdf" },
    { type: "jpg", icon: "photo_size_select_actual" },
    { type: "jpeg", icon: "photo_size_select_actual" },
    { type: "png", icon: "photo_size_select_actual" },
    { type: "gif", icon: "photo_size_select_actual" },
    { type: "tiff", icon: "photo_size_select_actual" },
    { type: "psd", icon: "photo_size_select_actual" },
    { type: "ai", icon: "photo_size_select_actual" },
    { type: "raw", icon: "photo_size_select_actual" },
    { type: "cr2", icon: "photo_size_select_actual" },
    { type: "crw", icon: "photo_size_select_actual" },
    { type: "nef", icon: "photo_size_select_actual" },
    { type: "pef", icon: "photo_size_select_actual" },
    { type: "eps", icon: "photo_size_select_actual" },
    { type: "indd", icon: "photo_size_select_actual" },
    { type: "webm", icon: "movie_creation" },
    { type: "mpg", icon: "movie_creation" },
    { type: "mp2", icon: "movie_creation" },
    { type: "mpeg", icon: "movie_creation" },
    { type: "mpe", icon: "movie_creation" },
    { type: "mpv", icon: "movie_creation" },
    { type: "ogg", icon: "movie_creation" },
    { type: "mp4", icon: "movie_creation" },
    { type: "M4P", icon: "movie_creation" },
    { type: "m4v", icon: "movie_creation" },
    { type: "avi", icon: "movie_creation" },
    { type: "wmv", icon: "movie_creation" },
    { type: "mov", icon: "movie_creation" },
    { type: "qt", icon: "movie_creation" },
    { type: "flv", icon: "movie_creation" },
    { type: "swf", icon: "movie_creation" },
    { type: "avchd", icon: "movie_creation" },
    { type: "pcm", icon: "audiotrack" },
    { type: "wav", icon: "audiotrack" },
    { type: "aiff", icon: "audiotrack" },
    { type: "mp3", icon: "audiotrack" },
    { type: "acc", icon: "audiotrack" },
    { type: "ogg", icon: "audiotrack" },
    { type: "wma", icon: "audiotrack" },
  ];

}
